export default "__VITE_ASSET__C5p4t8A7__"